import { FunctionComponent } from 'react';

import { FormControlLabel, Switch, SwitchProps, Typography } from '@mui/material';

export interface ISwitchInputProps extends Omit<SwitchProps, 'checked' | 'onChange' | 'disabled'> {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  /** Draws the label and the switch in the error colour — what a form switch shows after a failed submit. */
  error?: boolean;
}

/**
 * A switch and its label, for a value that is not a field of a form.
 *
 * `FormSwitchInput` is the answer whenever the value IS a form field, and it renders this one — so a
 * switch driving a component's own structural state (a section that reveals itself, the gate over a
 * dynamic list) looks and behaves exactly like every other switch in the portal, without inventing a
 * form field to hold something the form does not own.
 */
export const SwitchInput: FunctionComponent<ISwitchInputProps> = (props: ISwitchInputProps) => {

  const { label, checked, onChange, disabled, error, ...baseInputProps } = props;

  return (
    <FormControlLabel
      label={<Typography variant='body2'>{label}</Typography>}
      sx={{
        marginRight: '0px',
        color: error ? 'var(--color-error)' : disabled ? 'var(--color-text-disabled)' : ''
      }}
      disabled={disabled}
      control={(
        <Switch
          {...baseInputProps}
          onChange={(e) => onChange(e.target.checked)}
          checked={checked}
          disabled={disabled}
          color={error ? 'error' : baseInputProps.color}
        />
      )}
    />
  );
};
